/**
 * Tabs
 * @since 1.0.0
 */

export default () => {
  let containers = document.querySelectorAll('.js-tabs')
  if (containers.length < 1) return
  ;[...containers].forEach(container => {
    let triggers = container.querySelectorAll('.js-tabs-trigger')
    let panels = container.querySelectorAll('.js-tabs-panel')

    if (
      triggers.length < 1 ||
      panels.length < 1 ||
      triggers.length !== panels.length
    ) {
      throw Error('Tabs.js: missing one or more triggers and/or panels')
    }

    ;[...triggers].forEach(trigger => {
      trigger.addEventListener('click', addActive)
    })

    /**
     * Toggle .active classes if click a trigger
     */
    function addActive(e) {
      const clickedTrigger = e.currentTarget
      const name = clickedTrigger.dataset.name
      const matchingPanel = container.querySelector(
        `.js-tabs-panel[data-name=${name}]`
      )

      if (!clickedTrigger.classList.contains('active')) {
        closeAll()
        clickedTrigger.classList.add('active')
        matchingPanel.classList.add('active')
      }
    }

    /**
     * Remove all .active classes
     */
    function closeAll() {
      ;[...triggers].forEach(trigger => {
        if (trigger.classList.contains('active')) {
          trigger.classList.remove('active')
        }
      })
      ;[...panels].forEach(panel => {
        if (panel.classList.contains('active')) {
          panel.classList.remove('active')
        }
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Tabs.js